import { HistoricalScope } from '../scope/historical-scope';
import { LiveScope } from '../scope/live-scope';
import type { CreateRunFormData } from '../types';

interface ScopeStepProps {
  formData: CreateRunFormData;
  setField: <K extends keyof CreateRunFormData>(key: K, value: CreateRunFormData[K]) => void;
  isLiveEnvironment: boolean;
}

export function ScopeStep({ formData, setField, isLiveEnvironment }: ScopeStepProps) {
  if (isLiveEnvironment) {
    return <LiveScope formData={formData} setField={setField} />;
  }
  return <HistoricalScope formData={formData} setField={setField} />;
}
